import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Container, Grid, Typography, Box } from '@mui/material';
import './dashboard.scss';

export default function BuildingDashboard() {
  const navigate = useNavigate();
  return (
    <Container sx={{ p: 4, minHeight: '100vh' }}>
      <Button
        sx={{
          mb: 2,
          color: 'primary.main',
          '&:hover': { bgcolor: 'grey.200' },
        }}
        variant="text"
        onClick={() => {
          navigate('/help-center');
        }}
      >
        <span>← Back</span>
      </Button>

      <div className="help__center__container" lang="en">
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={2}>
            <Grid item>
              <Button variant="outlined" href="/help-center/dashboard">
                Overview
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" href="/help-center/building">
                Building
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/devices">
                Devices
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/settings">
                Settings
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" href="/help-center/map">
                Map
              </Button>
            </Grid>
          </Grid>
        </Box>

        <div className="help__center__hero">
          <h1>Building Overview Guide</h1>
        </div>
        <div className="content__box">
          <img src="/helpcenter/modify.png" alt="Modify Toggle" />
          <p>
            <strong>Modify Toggle:</strong> Enables edit mode for Zone
            components within the building editor or configuration area.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/addFloor.png" alt="Add Floor" />
          <p>
            <strong>Add New Zone:</strong> Appears after toggling Modify button.
            We can create new zone.
          </p>

          <p>
            <strong>Add Floor:</strong> Use this button to add a new floor to
            the building layout.
          </p>
        </div>
        <div className="content__box">
          <img
            src="/helpcenter/buildingOverview.png"
            alt="Building Overview Icon"
          />
          <p>
            <strong>Building Overview Icon:</strong> Opens the overall building
            summary and structure visualization.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/editBuilding.png" alt="Edit Building" />
          <p>
            <strong>Edit Building:</strong> Click this to modify building
            information or upload images and files.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/fetchGPS.png" alt="Fetch GPS" />
          <p>
            <strong>Fetch GPS:</strong> Fill in both Street and City to fetch
            GPS coordinates.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/report.png" alt="Report" />
          <p>
            <strong>Report:</strong> Upload your report here.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/zoneDevice.png" alt="Zone Device" />
          <p>
            <strong>Zone Device:</strong> Select devices to display within the
            Zone.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/device.png" alt="Device" />
          <p>
            <strong>Device:</strong> Latest temperature value.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/icmeter.png" alt="IC Meter" />
          <p>
            <strong>IC Meter:</strong> By clicking on device you can open up the
            graph of latest values.
          </p>
        </div>
        <div className="content__box">
          <img src="/helpcenter/tooltip.png" alt="Tooltip" />
          <p>
            <strong>Tooltip:</strong> By clicking on chart you can open up the
            tooltip with more detailed values.
          </p>
        </div>
      </div>
    </Container>
  );
}
